<div class="modal-header">
  <button class="btn btn-secondary mr-2" type="button" (click)="cancel()">Cancel</button>

  <div>
    <button *ngIf="checkinService.mode == 'checkin' && !checkinService.rfidEnabled" [promiseBtn]="submitComplete" type="button" (click)="completeCheckin(false)" class="btn btn-danger mr-2">Check In</button>
    <button *ngIf="checkinService.mode == 'checkin' && checkinService.rfidEnabled" [promiseBtn]="submitComplete" type="button" (click)="completeCheckin(false)" class="btn btn-danger mr-2">Check In / No CEUs</button>
    <button *ngIf="checkinService.rfidEnabled" class="btn btn-success" type="button" [promiseBtn]="submitComplete" (click)="completeCheckin(true)">
      <span *ngIf="checkinService.mode == 'checkin' ">Check In/ CEUs</span>
      <span *ngIf="checkinService.mode == 'rekey'">Save</span>
    </button>
  </div>
</div>
<div *ngIf="initialized" class="pl-3 pr-3 pt-0 pb-3 vh-100">
  <div class="row">
    <div class="col-md-6 pt-3">
      <form #myForm="ngForm">
        <ng-container *ngIf="checkinService.mode == 'checkin'">
          <div class="form-row">
            <div class="form-group col-md-12">
              <label for="firstName">First Name</label>
              <input (focus)="onInputFocus($event)" (mouseup)="mouseUp($event)" (change)="onInputChange($event)" type="text" [(ngModel)]="user.firstName" name="firstName" class="form-control" id="firstName" aria-describedby="firstName"/>
              <div class="invalid-message">First name is required</div>
            </div>
            <div class="form-group col-md-12">
              <label for="lastName">Last Name</label>
              <input (focus)="onInputFocus($event)" (mouseup)="mouseUp($event)" (change)="onInputChange($event)" type="text" [(ngModel)]="user.lastName" name="lastName" class="form-control" id="lastName"/>
              <div class="invalid-message">Last name is required</div>
            </div>
          </div>
          <!--        <div class="form-group">-->
          <!--          <label for="fullName">Full Name, Credentials and pronouns (if desired)</label>-->
          <!--          <input type="text" [(ngModel)]="user.nameForBadge" name="nameForBadge" class="form-control" id="fullName" />-->
          <!--          <div class="invalid-message">Full name is required</div>-->
          <!--        </div>-->
          <div class="form-group">
            <label for="fullName">Pronouns (optional)</label>
            <!--        <label for="fullName">Home State (Optional)</label>-->
            <!--          <select class="form-control" [(ngModel)]="user.pronouns" id="pronouns" name="pronouns">-->
            <!--            <option value="Alabama">Alabama</option>-->
            <!--            <option value="Alaska">Alaska</option>-->
            <!--            <option value="Arizona">Arizona</option>-->
            <!--            <option value="Arkansas">Arkansas</option>-->
            <!--            <option value="California">California</option>-->
            <!--            <option value="Colorado">Colorado</option>-->
            <!--            <option value="Connecticut">Connecticut</option>-->
            <!--            <option value="Delaware">Delaware</option>-->
            <!--            <option value="Florida">Florida</option>-->
            <!--            <option value="Georgia">Georgia</option>-->
            <!--            <option value="Hawaii">Hawaii</option>-->
            <!--            <option value="Idaho">Idaho</option>-->
            <!--            <option value="Illinois">Illinois</option>-->
            <!--            <option value="Indiana">Indiana</option>-->
            <!--            <option value="Iowa">Iowa</option>-->
            <!--            <option value="Kansas">Kansas</option>-->
            <!--            <option value="Kentucky">Kentucky</option>-->
            <!--            <option value="Louisiana">Louisiana</option>-->
            <!--            <option value="Maine">Maine</option>-->
            <!--            <option value="Maryland">Maryland</option>-->
            <!--            <option value="Massachusetts">Massachusetts</option>-->
            <!--            <option value="Michigan">Michigan</option>-->
            <!--            <option value="Minnesota">Minnesota</option>-->
            <!--            <option value="Mississippi">Mississippi</option>-->
            <!--            <option value="Missouri">Missouri</option>-->
            <!--            <option value="Montana">Montana</option>-->
            <!--            <option value="Nebraska">Nebraska</option>-->
            <!--            <option value="Nevada">Nevada</option>-->
            <!--            <option value="New Hampshire">New Hampshire</option>-->
            <!--            <option value="New Jersey">New Jersey</option>-->
            <!--            <option value="New Mexico">New Mexico</option>-->
            <!--            <option value="New York">New York</option>-->
            <!--            <option value="North Carolina">North Carolina</option>-->
            <!--            <option value="North Dakota">North Dakota</option>-->
            <!--            <option value="Ohio">Ohio</option>-->
            <!--            <option value="Oklahoma">Oklahoma</option>-->
            <!--            <option value="Oregon">Oregon</option>-->
            <!--            <option value="Pennsylvania">Pennsylvania</option>-->
            <!--            <option value="Rhode Island">Rhode Island</option>-->
            <!--            <option value="South Carolina">South Carolina</option>-->
            <!--            <option value="South Dakota">South Dakota</option>-->
            <!--            <option value="Tennessee">Tennessee</option>-->
            <!--            <option value="Texas">Texas</option>-->
            <!--            <option value="Utah">Utah</option>-->
            <!--            <option value="Vermont">Vermont</option>-->
            <!--            <option value="Virginia">Virginia</option>-->
            <!--            <option value="Washington">Washington</option>-->
            <!--            <option value="Washington">Washington D.C.</option>-->
            <!--            <option value="West Virginia">West Virginia</option>-->
            <!--            <option value="Wisconsin">Wisconsin</option>-->
            <!--            <option value="Wyoming">Wyoming</option>-->
            <!--        </select>-->
            <input (focus)="onInputFocus($event)" (mouseup)="mouseUp($event)" (change)="onInputChange($event)" type="text" [(ngModel)]="user.pronouns" name="pronouns" class="form-control" id="pronouns"/>
          </div>

          <div class="form-group">
            <label for="fullName">Affiliation</label>
            <input (focus)="onInputFocus($event)" (mouseup)="mouseUp($event)" (change)="onInputChange($event)" type="text" [(ngModel)]="user.affiliation" name="affiliation" class="form-control" id="affiliation"/>
          </div>

          <!--        <div class="form-group">-->
          <!--          <label for="fullName">Credentials</label>-->
          <!--          <input type="text" [(ngModel)]="user.credentials" name="credentials" class="form-control" id="credentials" />-->
          <!--        </div>-->
          <div class="form-group">
            <label for="fullName">Phone</label>
            <input (focus)="onInputFocus($event)" (mouseup)="mouseUp($event)" (change)="onInputChange($event)" type="text" [(ngModel)]="user.phoneNumber" [mask]="'(000) 000-0000'" required inputmode="tel" name="phoneNumber" class="form-control" id="fullName"/>
            <div class="invalid-message">Phone number is required</div>
          </div>
          <ng-container *ngIf="conferenceId == 95">
            <div *ngIf="user.packageId != 543" class="form-group">
              <div class="alert alert-warning">We want attendees to feel as comfortable as possible while attending the APBA Convention. We each have unique preferences and needs when it comes to being in social spaces and communicating with others. To help facilitate our ability to share those needs and preferences, you can add a colored symbol to your badge so that others can follow your lead</div>
            </div>

            <div *ngIf="user.packageId != 543" class="form-group">
              <label for="fullName">Communication Preference</label>
              <select class="form-control" [(ngModel)]="user.badgeTemplateOverride" name="badgeTemplateOverride">
                <option [ngValue]="null">I am actively seeking communication</option>
                <option value="APBA-Badge-yellow.png">I am comfortable with familiar people, or greeting from a slight distance</option>
                <option value="APBA-Badge-red.png">I am doing my own thing and happy to accept a wave from 6 feet or more</option>
              </select>
            </div>
          </ng-container>
        </ng-container>
      </form>
    </div>


    <div *ngIf="checkinService.mode == 'checkin'" class="col-md-6 text-center">
      <h5>Badge Preview</h5>
      <img style="border: 1px solid black;" class="img-fluid" [src]="'get-Badge?conferenceId=' + conferenceId + '&userId=' + user.id + '&firstName=' + user.firstName + '&lastName=' + user.lastName + '&fullName=' + user.nameForBadge + '&pronouns=' + user.pronouns + '&affiliation=' + user.affiliation + '&credentials=' + user.credentials?.replace('&','&amp;') + '&badgeTemplateOverride=' + user.badgeTemplateOverride"/>
    </div>
  </div>
  <div class="d-flex justify-content-around">
    <!--  <button class="btn btn-success btn-lg">Yes I need CEUs</button>-->

  </div>
  <div *ngIf="checkinService.rfidEnabled" style="padding: 0rem; display:flex; align-items: center; justify-content: center; height: 8rem;width:100%; border: 1px solid; border-radius: 25px;" [style.border-color]="formDirty && finalRFIDValue.length != 10? '#bb3734': 'gray'">
    <div style="position: relative; width: 100%" *ngIf="!finalRFIDValue">

      <h3 style="margin-bottom: 0; margin-top:1rem; text-align: center" [style.color]="formDirty && finalRFIDValue.length != 10? '#bb3734': 'black'">Please scan RFID Tag for CEU Tracking</h3>

      <h1 class="text-center text-warning" style="font-size: 4rem">
        <i class="fas fa-signal-stream"></i></h1>


    </div>
    <div *ngIf="finalRFIDValue">
      <h3 style="margin-bottom: 0; margin-top:1rem;">RFID Tag Entered!</h3>
      <h1 class="text-center text-success" style="font-size: 4rem">
        <i class="fas fa-signal-stream"></i></h1>
    </div>
  </div>
  <div class="invalid-message-visible" *ngIf="formDirty && finalRFIDValue.length != 10">Please scan a valid RFID code</div>

  <ng-container *ngIf="conferenceId == 168">
    <div class="text-center pt-3 pl-2">
      <div class="form-row  text-left">Autism Allies is our proud platinum supporter of BABAT and would love to share more about their program with you. Please indicate your willingness to receive email communications below:</div>
    </div>
    <div>
      <select class="form-control col-md-3">
        <option value="yes">I Consent</option>
        <option value="no">Opt Out</option>
      </select>

    </div>
  </ng-container>

  <div class="text-center pt-3">
    <div class="form-row small text-left">I acknowledge that during this event, I may be photographed by conference personnel. I grant permission to use that material in emails or media posts or on the website and I will make no monetary or other claim against the conference for said use.</div>
  </div>

</div>
<div class="bg-light" style="position:absolute; bottom:0;left:0;right:0;">
  <div>
    <div class="simple-keyboard2"></div>
  </div>
</div>


